import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Typography, Table } from "antd";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import moment from "moment";
import { useQuery } from "react-query";
import { getAssetLogs } from "../../../api/server";
const { Title, Text } = Typography;

const History = (props) => {
  const { hide, visible, activeRecord, scope, branchId } = props;
  const intl = useIntl();
  const [disabled, setDisabled] = useState(true);
  const { scopePrefix } = useSelector((state) => state.user);

  const onCancel = () => {
    hide();
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const scopePre = branchId
    ? `branches/${branchId}/${scope}`
    : `${scopePrefix}${scope}`;

  const { isLoading, data } = useQuery(
    [activeRecord],
    async () => {
      const result = await getAssetLogs({
        assetId: activeRecord.id,
        scope: scopePre,
      });
      return result.data.data.items;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: activeRecord !== null,
    }
  );

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.assets.operator_name",
      }),
      dataIndex: "operator",
      render: (text) => {
        return <Text>{text && text["name"]}</Text>;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.assets.updated_at",
      }),
      dataIndex: "created_at",
      render: (text) => (
        <Text>{text && moment(text).format("DD/MM/YYYY")}</Text>
      ),
    },
    {
      title: intl.formatMessage({
        id: "app.assets.updated_at_hour",
      }),
      dataIndex: "created_at",
      render: (text) => <Text>{text && moment(text).format("HH:mm")}</Text>,
    },
    {
      title: intl.formatMessage({
        id: "app.assets.action",
      }),
      dataIndex: "action",
      render: (text) => (
        <Text>
          {intl.formatMessage({
            id: `app.assets.${text}`,
          })}
        </Text>
      ),
    },
    {
      title: intl.formatMessage({
        id: "app.assets.value",
      }),
      dataIndex: "value",
      render: (text) => {
        return <Text>{text}</Text>;
      },
    },
  ];

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          className="header"
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          <FormattedMessage id={`app.assets.history`} />
        </Title>
        <Table
          bordered
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={data}
          loading={isLoading}
          pagination={false}
          scroll={{ y: window.innerHeight - 400 }}
        />
      </div>
    </Modal>
  );
};
History.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default History;
